module.exports = __webpack_public_path__ + "img/logo-office.4007754f.png";